<template>
    <v-modal
        v-if="show"
        title="Webhook Tracking Log"
        @close="$emit('close')"
        scroll
        size="extra-large">
        <div slot="contents">
            <div class="modal-content">
                <h3 class="stack-m">Response Body</h3>
                <pre class="no-margin"><code v-highlight>{{expandedData.responseBody}}</code></pre>
            </div>
            <div class="modal-content">
                <h3 class="stack-m">Headers</h3>
                <p v-if="!expandedData.headers.length" class="text-center text-muted">{{noData}}</p>
                <pre v-else class="no-margin"><code v-highlight v-for="header in expandedData.headers">{{header}}</code></pre>
            </div>
            <div class="modal-content">
                <h3 class="stack-m">Links</h3>
                <pre class="no-margin"><code v-highlight.json v-for="link in expandedData.links">{{link}}</code></pre>
            </div>
            <div class="modal-content">
                <h3 class="stack-m">Payload</h3>
                <pre class="no-margin"><code v-highlight.json>{{formatCode(expandedData.payload)}}</code></pre>
            </div>
        </div>
    </v-modal>
</template>

<script>
    import vModal from '@/components/modal/v-modal';

    export default {
        components: {
            vModal,
        },
        props: {
            show: {
                type: Boolean,
                default: false,
            },
            expandedData: {
                type: Object,
                default: {},
            },
        },
        data() {
            return {
                noData: 'No API data available',
            };
        },
        methods: {
            formatCode(data) {
                try {
                    const parsedData = JSON.parse(data);
                    return JSON.stringify(parsedData, null, 4);
                } catch (error) {
                    return data;
                }
            },
        },
    };
</script>
